import React from 'react';
import Joyride, { EVENTS, ACTIONS, STATUS } from 'react-joyride';
import Tooltip from './Tooltip';

const steps = [
  {
    target: '.taxcon-set-outlets-section',
    disableBeacon: true,
    placement: 'top-end',
    title: 'Tax Before Discount setting is here!',
    content:
      'If your FnB business is in Jakarta (and some other) area, this feature improvement is for you.',
    locale: { next: 'Lets Try' },
  },
  {
    target: '.taxcon-ftue-modal',
    disableBeacon: true,
    placement: 'right',
    title: 'Move Outlets Based on Local Government Tax Regulations',
    content: (
      <div>
        <a
          href="http://blog.mokapos.com/cara-menghitung-dpp-pajak-restoran"
          target="_blank"
        >
          <u>Click here</u>
        </a>
        &nbsp;to read more about this.
      </div>
    ),
    locale: 'next',
  },
  {
    target: '.taxcon-ftue-confirm-button',
    disableBeacon: true,
    placement: 'top-end',
    title: 'Click Confirm when finished',
    content:
      'Be sure outlets are being put at the right setting according to local tax regulation.',
    locale: 'next',
  },
  {
    target: '.taxcon-ftue-save-button',
    disableBeacon: true,
    placement: 'top-end',
    title: 'That is all!',
    content: 'Finish by clicking save button and all is set!',
    locale: { close: 'Done' },
  },
];

class TaxConfigurationFtue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTourRunning: true,
      stepIndex: 0, // a controlled tour
    };
  }

  render() {
    const { isTourRunning, stepIndex } = this.state;

    return (
      <Joyride
        disableScrolling
        disableOverlayClose
        disableCloseOnEsc
        run={isTourRunning}
        steps={steps}
        stepIndex={stepIndex}
        callback={this.handleJoyrideCallback}
        tooltipComponent={Tooltip}
        continuous
        styles={{
          options: {
            arrowColor: '#4A4A4A',
            zIndex: 1051, // Since modal has z-index of 1050
          },
        }}
        floaterProps={{
          disableAnimation: true,
          id: 'taxConfigurationFtue',
        }}
      />
    );
  }

  componentDidMount() {
    this.setPageContentWrapperHeight();
  }

  setPageContentWrapperHeight = () => {
    try {
      const $pageContentWrapper = document.getElementById(
        'page-content-wrapper'
      );
      const $fixedContentSidebar = document.getElementById('checkout-form');
      $pageContentWrapper.style.height = `${$fixedContentSidebar.clientHeight}px`;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  resetPageContentWrapperHeight = () => {
    try {
      const $pageContentWrapper = document.getElementById(
        'page-content-wrapper'
      );
      $pageContentWrapper.style.height = '';
      $pageContentWrapper.style.overflow = '';
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  handleJoyrideCallback = data => {
    const { stepIndex, isModalOpen } = this.state;
    const { index, action, type, status } = data;
    const {
      onCompletion,
      onRequestModalOpen,
      onRequestModalClose,
    } = this.props;

    if ([STATUS.FINISHED, STATUS.SKIPPED, STATUS.PAUSED].includes(status)) {
      this.resetPageContentWrapperHeight();
      onRequestModalClose();
    }

    // If cross icon is clicked, we are done (consider tour ends)
    if (action === ACTIONS.CLOSE || type === EVENTS.TOUR_END) {
      this.setState({
        isTourRunning: false,
        stepIndex: 0,
      });
      onCompletion();
      return;
    }

    if (type === EVENTS.STEP_AFTER) {
      // `stepIndex` is the index we want to go
      // `index` is the current index
      // If they are equal, then it is a normal 1-step move and we need to compute it
      let nextIndex = stepIndex;
      if (index === stepIndex) {
        if (action === ACTIONS.NEXT) {
          nextIndex++;
        } else if (action === ACTIONS.PREV) {
          nextIndex--;
        }
      }

      // Steps between 0 and 3 requires the modal to be open
      const needModalOpen = nextIndex > 0 && nextIndex < 3;

      // If the required modal state is different with what the next step demands,
      // we need to request a change.
      if (!needModalOpen) {
        onRequestModalClose();
      } else if (!isModalOpen) {
        onRequestModalOpen();
      }

      this.setState({
        stepIndex: nextIndex,
      });
    }
  };
}

TaxConfigurationFtue.defaultProps = {
  onCompletion: () => {},
  onRequestModalOpen: () => {},
  onRequestModalClose: () => {},
};

export default TaxConfigurationFtue;
